import type { DagRowRead } from '@/types/dag'

export function formatInputValue(value: unknown, format: string): string {
  if (value == null) return ''

  const num = typeof value === 'number' ? value : parseFloat(String(value))

  if (format === 'percent' && !Number.isNaN(num)) {
    return String(parseFloat((num * 100).toFixed(2)))
  }

  if ((format === 'currency' || format === 'number') && !Number.isNaN(num)) {
    return String(parseFloat(num.toFixed(2)))
  }

  return String(value)
}

export function getRowHeaderLabel(row: DagRowRead, index: number) {
  const description = String(row.cells['description'] ?? '').trim()
  const sku = String(row.cells['plan_sku_num'] ?? '').trim()

  if (description && sku) {
    return `${description} (${sku})`
  }
  if (description) {
    return description
  }
  if (sku) {
    return `SKU ${sku}`
  }
  return `Line ${index + 1}`
}
